module.exports = __webpack_public_path__ + "img/pic5.6732cf82.png";